













































































































import Vue from 'vue'
import {ConnectionStates, LoginStates} from '@js/interfaces'
import {mockPromise} from '@js/utils'
import config from '@/config.json'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default Vue.extend({
  name: 'login',
  data() {
    return {
      showLogin: false as boolean,
      email: '' as string,
      password: '' as string,
      password2: '' as string,
      state: LoginStates.login as string,
      connection: ConnectionStates.idle as string,
      LoginStates,
      ConnectionStates
    }
  },
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  mounted() {
    setTimeout(() => {
      this.showLogin = true
      this.$refs.email.focus()
    }, 0)
  },
  computed: {
    getStateLabel(): string {
      return this.connection
      ? this.$t(`states.${this.connection}`)
      : ''
    },
    getMicroserviceAddress() {
      // @ts-ignore
      let {host, port} = process.env.NODE_ENV === 'development'
      ? config.development.microservice
      // @ts-ignore
      : config.production.microservice

      if(!host) host = `//${location.hostname}`
      port = port ? `:${port}` : ''

      return `${host}${port}`
    },
    getBrandingLogo(): string {
      return this.$i18n.whitelabel.logoImg
    },
    getSubBrandingLogo(): string {
      return this.$i18n.whitelabel.logoImgSub
    },
    getPasswordAutoComplete(): string {
      let rtn: string = ''
      switch(this.state) {
        case this.LoginStates.signUp:
          rtn = 'new-password'
          break
        default: rtn = 'on'
      }
      return rtn
    },
    getConnectionClass(): string {
      return this.connection ? 'connection--' + this.connection : ''
    },
    getIsSubmitEnabled(): boolean {
      let state: boolean = true

      if(this.state === LoginStates.signUp) {
        if(this.password && this.password2 &&
          this.password !== this.password2) {
          state = false
        }
      }
      return state
    }
  },
  methods: {
    async onError(data: unknown) {
      // tslint:disable-next-line
      console.error(data)
      this.connection = ConnectionStates.error
      await mockPromise(1000, true)
      this.connection = ConnectionStates.idle
    },
    async onToken(token: string) {
      this.connection = token !== 'ACCESS DENIED'
      ? ConnectionStates.authorized
      : ConnectionStates.authFail

      await mockPromise(900, true)

      if(this.connection === ConnectionStates.authorized) {
        this.$emit('setToken', token)
        return
      }

      this.connection = ConnectionStates.idle
    },
    onSubmit(status: boolean): void {
      if(this.state === LoginStates.login) this.connection = ConnectionStates.connecting
    },
    setState(requestedState: string): void {
      this.state = LoginStates[requestedState as keyof typeof LoginStates]
    }
  },
  watch: {
    async connection(connectionString: string) {
      if(connectionString === ConnectionStates.connecting) {
        await mockPromise(1000, true) // People do not trust auth services that are too fast - it's weird, I know.

        const url = `${this.getMicroserviceAddress}/api/get-token`
        const fetchy = await fetch(url, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            user: this.email,
            password: this.password
          })
        }).catch(this.onError) as Response | undefined

        const data = fetchy ? await fetchy.json() : ''

        fetchy && fetchy.status === 200 && data
        ? this.onToken(data)
        : this.onError(data)
      }
    }
  }
})
